module.exports = "<span :class=\"['mui-tag', {\n  'mui-tag-line': line,\n  'mui-tag-orange': type === 'orange',\n  'mui-tag-white': type === 'white',\n  'mui-tag-green': type === 'green',\n  'mui-tag-gray': type === 'gray',\n  'mui-tag-purple': type === 'purple'\n}]\"><slot>{{ text }}</slot></span>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tag/index.vue
 ** module id = 178
 ** module chunks = 0
 **/